import Image from 'next/legacy/image';

import { H2, H4, H6 } from '@common/headline';
import { BodySmall } from '@common/body';
import Button from '@common/Button/Button';
import Icon from '@common/Icons/Icon';

import Pepper from '@public/img/our-story/pepper.png';
import Star from '@public/img/our-story/star.png';
import Team from '@public/img/our-story/team.png';
import TeamMobile from '@public/img/our-story/team-mobile.png';
import Glassdoor from '@public/img/our-story/glassdoor.svg';
import GlassdoorStar from '@public/img/our-story/glassdoor-star.svg';

export const WeAreHiring = (): JSX.Element => (
  <div className="relative bg-dawn-blue md:px-[40px] lg:px-[60px]">
    <div className="flex flex-col px-3 pb-14 pt-16 lg:container lg:m-auto lg:flex-row lg:px-0 lg:pb-12 lg:pt-16">
      <div className="z-10 flex flex-1 flex-col items-start">
        <div className="mb-4 text-blue">
          <H2>
            We&apos;re <span className="text-mono-white">hiring</span>
          </H2>
        </div>
        <div className="mb-6 text-blue">
          <H4>
            We&apos;re trying to solve something no one has ever solved before.
            To do that, we need brilliant, driven, passionate people in every
            position. Join us.
          </H4>
        </div>
        <div className="mb-14">
          <a
            href={`https://apply.workable.com/secondnature/?utm_source=${encodeURIComponent(
              'Second Nature Website',
            )}`}
          >
            <Button
              type="Primary"
              colour="NavyBlue"
              fullWidth={false}
              icon={<Icon name="rightArrow" />}
            />
          </a>
        </div>
        <div className="hidden flex-col items-center justify-center lg:flex">
          <div className="mb-3">
            <Image src={Glassdoor} alt="Glassdoor" width={122} height={24} />
          </div>
          <div className="flex flex-row">
            <div className="mr-3 border-r-[1px] border-dawn-blue-800 pr-2 text-blue-100">
              <BodySmall>4.8</BodySmall>
            </div>
            {[...new Array(5)].map((_, index) => (
              <div className="mr-1 h-6 w-6 last:mr-0" key={index}>
                <Image
                  src={GlassdoorStar}
                  width={24}
                  height={24}
                  objectFit="cover"
                  objectPosition="center center"
                  alt="Glassdoor star"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="z-10 mb-[250px] flex flex-1 items-start lg:mb-0 lg:justify-center">
        <div className="rounded-3xl bg-mono-white p-6">
          <div className="flex flex-row items-center">
            <div className="relative mr-3">
              <Image src={Pepper} alt="Pepper" width={55} height={55} />
              <div className="absolute bottom-0 right-0 z-10">
                <Image src={Star} alt="Star" width={17} height={17} />
              </div>
            </div>
            <div>
              <H6>Pepper</H6>
              <BodySmall>Chief Dog Officer</BodySmall>
            </div>
          </div>
          <H4>It&apos;s a great place to work!</H4>
        </div>
      </div>
      <div className="z-10 flex flex-col items-center justify-center lg:hidden">
        <div className="mb-3">
          <Image src={Glassdoor} alt="Glassdoor" width={122} height={24} />
        </div>
        <div className="flex flex-row">
          <div className="mr-3 border-r-[1px] border-dawn-blue-800 pr-2 text-blue-100">
            <BodySmall>4.8</BodySmall>
          </div>
          {[...new Array(5)].map((_, index) => (
            <div className="mr-1 h-6 w-6 last:mr-0" key={index}>
              <Image
                src={GlassdoorStar}
                width={24}
                height={24}
                objectFit="cover"
                objectPosition="center center"
                alt="Glassdoor star"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
    <Image
      className="!hidden lg:!block"
      layout="fill"
      objectFit="contain"
      objectPosition="right bottom"
      src={Team}
      alt="Second Nature team"
    />
    <Image
      className="lg:!hidden"
      layout="fill"
      objectFit="cover"
      objectPosition="center bottom"
      src={TeamMobile}
      alt="Second Nature team"
    />
  </div>
);
